let viewer;
let optionValues;
let materialNames;
var materialChangeStatus = {};

/* ==========================================================================
 * CHROMCRAFT FIX 2026-10-22: Add to Cart is never disabled on load.
 * Before: on page load the button was disabled and covered by an invisible
 * ".cart-btn-cover" until the 3D viewer loaded and every material was picked.
 * If the viewer was slow or failed, the product could not be bought at all.
 * Now:
 *   1. The button stays enabled. There is no cover.
 *   2. When the material panel is built, a default material is preselected
 *      for each option (the one matching the current variant, else the
 *      first one). Set window.COHOOM_PRESELECT_DEFAULTS = false to turn
 *      this off.
 *   3. On tap, if a required material is missing, that submit is blocked
 *      and a large aria-live message appears next to the button. The page
 *      scrolls to and focuses the first missing option.
 *   4. Fallback: if the options have not loaded 10 s after page ready (or
 *      the viewer errors), Add to Cart works normally. properties[Material]
 *      is then set to a note so staff know to confirm the material.
 * ========================================================================== */
var COHOOM_FIX = {
  fallbackMs: 10000,
  readyAt: 0,
  optionsReady: false,  // true once the material panel is built (optionValues set)
  fallback: false,      // true once the 10 s fallback has kicked in
  gate: true,           // false for modular "mod" products (never gated)
  fallbackNote: "Not selected online (3D configurator did not load) - Chromcraft will confirm with customer",
};

function cohoomFixPreselectEnabled() {
  return typeof window.COHOOM_PRESELECT_DEFAULTS === "undefined" ? true : !!window.COHOOM_PRESELECT_DEFAULTS;
}

function cohoomFixMissingOptions() {
  if (!optionValues || typeof optionValues !== "object") return [];
  return Object.keys(optionValues).filter(function (k) { return optionValues[k] == null; });
}

function cohoomFixInjectStyles() {
  if (document.getElementById("cohoom-fix-style")) return;
  var css =
    ".cohoom-fix-msg{display:none;margin:12px 0 4px;padding:14px 16px;border:3px solid #b3261e;" +
    "border-radius:6px;background:#fff4f2;color:#1a1a1a;font-size:20px;line-height:1.45;font-weight:600}" +
    ".cohoom-fix-msg.is-visible{display:block}" +
    ".cohoom-fix-msg.is-info{border-color:#033c5a;background:#eef5f9}" +
    ".cohoom-option.cohoom-fix-missing{outline:3px solid #b3261e;outline-offset:4px;border-radius:4px}" +
    ".cohoom-option:focus{outline:3px solid #033c5a;outline-offset:4px}";
  $("<style id='cohoom-fix-style'>" + css + "</style>").appendTo("head");
}

function cohoomFixMessageEl() {
  var $msg = $("#cohoom-fix-msg");
  if (!$msg.length) {
    $msg = $("<div id='cohoom-fix-msg' class='cohoom-fix-msg' role='alert' aria-live='assertive' tabindex='-1'></div>");
    var $buttons = $(".product-form__buttons").first();
    if ($buttons.length) { $buttons.after($msg); } else { $("body").append($msg); }
  }
  return $msg;
}

function cohoomFixShowMessage(text, isInfo) {
  var $msg = cohoomFixMessageEl();
  $msg.toggleClass("is-info", !!isInfo).text(text).addClass("is-visible");
}

function cohoomFixHideMessage() {
  $("#cohoom-fix-msg").removeClass("is-visible").text("");
  $(".cohoom-option").removeClass("cohoom-fix-missing");
}

function cohoomFixFocusFirstMissing(missing) {
  var first = null;
  $(".cohoom-option").each(function () {
    var name = $(this).find(".cohoom-block").first().attr("data-option-name");
    if (missing.indexOf(name) !== -1) {
      $(this).addClass("cohoom-fix-missing").attr("tabindex", "-1");
      if (!first) first = this;
    }
  });
  if (typeof togglePanel === "function" && $("#cohoom-panel-mobile").length && !$("#cohoom-panel-mobile").is(":visible")) {
    try { togglePanel(); } catch (e) {}
  }
  if (first) {
    first.scrollIntoView({ behavior: "smooth", block: "center" });
    try { first.focus({ preventScroll: true }); } catch (e) {}
  }
}

/* Returns true if this Add to Cart tap may continue to the theme's normal add-to-cart code. */
function cohoomFixCanSubmit() {
  if (!COHOOM_FIX.gate || COHOOM_FIX.fallback) return true;
  if (!COHOOM_FIX.optionsReady) {
    var waited = Date.now() - COHOOM_FIX.readyAt;
    if (waited >= COHOOM_FIX.fallbackMs) { cohoomFixEnterFallback("tap after timeout"); return true; }
    cohoomFixShowMessage("Loading your material choices\u2026 please wait a moment and tap Add to Cart again.", true);
    return false;
  }
  var missing = cohoomFixMissingOptions();
  if (!missing.length) { cohoomFixHideMessage(); return true; }
  // Some 3D models carry internal component names (e.g. "obj_623abb..."); do not show those to shoppers.
  var labels = missing.map(function (n) { return /^obj_|^[0-9a-f]{16,}$/i.test(n) ? "material option" : n; });
  labels = labels.filter(function (n, i) { return labels.indexOf(n) === i; });
  cohoomFixShowMessage("Please choose your " + labels.join(", ") + " above before adding to cart.");
  cohoomFixFocusFirstMissing(missing);
  return false;
}

function cohoomFixEnterFallback(reason) {
  if (COHOOM_FIX.optionsReady || COHOOM_FIX.fallback) return;
  COHOOM_FIX.fallback = true;
  console.warn("[cohoom-fix] material options unavailable (" + reason + "); Add to Cart left fully enabled.");
  $(".cart-btn-cover").remove();
  $('button[name="add"]').prop("disabled", false);
  $("#show-sticky-product").prop("disabled", false);
  // Overwrite any template placeholder (some pages ship value="saminthebox") so staff see a clear note.
  $("#material").val(COHOOM_FIX.fallbackNote);
  $(".skeleton-content").remove();
  cohoomFixHideMessage();
}

/* Called right after the material panel is built (optionValues exists). */
function cohoomFixOnOptionsReady() {
  COHOOM_FIX.optionsReady = true;
  if (COHOOM_FIX.fallback) {
    // Options arrived late: leave fallback mode and use the real choices.
    COHOOM_FIX.fallback = false;
    if ($("#material").val() === COHOOM_FIX.fallbackNote) $("#material").val("");
  }
  if (COHOOM_FIX.gate && cohoomFixPreselectEnabled()) cohoomFixPreselectDefaults();
}

/* Pick a material block for one option: match the current variant's title/SKU, else the first block. */
function cohoomFixDefaultBlock($option) {
  var $blocks = $option.find(".cohoom-block");
  if (!$blocks.length) return null;
  try {
    var variantId = String($('form[data-type="add-to-cart-form"] input[name="id"]').first().val() || "");
    var variants = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.variants) || [];
    var v = variants.filter(function (x) { return String(x.id) === variantId; })[0];
    if (v) {
      var hay = ((v.public_title || v.name || "") + " " + (v.sku || "")).toLowerCase();
      var match = $blocks.filter(function () {
        var n = $.trim($(this).find(".cohoom-material-name").text()).toLowerCase();
        return n && new RegExp("(^|[^a-z0-9])" + n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "([^a-z0-9]|$)").test(hay);
      });
      if (match.length) return match.first();
    }
  } catch (e) {}
  return $blocks.first();
}

function cohoomFixSleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

async function cohoomFixPreselectDefaults() {
  var $options = $(".cohoom-option");
  for (var i = 0; i < $options.length; i++) {
    var $opt = $options.eq(i);
    var name = $opt.find(".cohoom-block").first().attr("data-option-name");
    if (!name || optionValues[name] != null) continue;
    var $blk = cohoomFixDefaultBlock($opt);
    if (!$blk) continue;
    // cohoom.js ignores clicks while a 3D material change is running; wait (max ~10 s) for it.
    if (typeof checkIfMaterialsAllChanged === "function") {
      for (var t = 0; t < 40 && !checkIfMaterialsAllChanged(); t++) await cohoomFixSleep(250);
    }
    $blk.trigger("click");   // same handler as a shopper tap: 3D update, #material, screenshot
    await cohoomFixSleep(60);
    if (optionValues[name] == null) {
      // Viewer still busy/stuck: record the choice without the 3D update so the order data is complete.
      $opt.find(".fa-circle-check").css("color", "#033c5a");
      $opt.find(".cohoom-material-thumbnail").removeClass("cohoom-material-thumbnail-selected");
      $blk.find(".cohoom-material-thumbnail").addClass("cohoom-material-thumbnail-selected");
      optionValues[name] = $blk.attr("data-material-id");
      $("#material").val(generateOptionDescription());
    }
  }
}

/* Capture-phase guard: runs before the theme's jQuery add-to-cart handlers.
 * Only the main product form and the sticky bar are guarded (the original code
 * disabled every button[name="add"] on the page, including recommendation cards). */
var COHOOM_FIX_BTNS = "#product-add-to-cart, #product-sticky-add-to-cart, #show-sticky-product";
function cohoomFixGuard(e) {
  if (e.type === "submit") {
    var form = e.target;
    if (!form || !form.querySelector || !form.querySelector("#product-add-to-cart, #product-sticky-add-to-cart")) return;
  } else {
    var t = e.target && e.target.closest ? e.target.closest(COHOOM_FIX_BTNS) : null;
    if (!t) return;
  }
  if (!cohoomFixCanSubmit()) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}
document.addEventListener("click", cohoomFixGuard, true);
document.addEventListener("submit", cohoomFixGuard, true);
/* ======================== END CHROMCRAFT FIX ============================== */


const optionOrder = {
  "Wood Finish": 0,
  "Metal Finish": 1,
  "Column": 2,
  "Column Finish": 3,
  "Fabric": 4,
  "Metal": 5,
};

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getFileNameFromUrl(url) {
  let urlObj = new URL(url);

  let pathname = urlObj.pathname;

  let imageName = pathname.split("/").pop();

  imageName = imageName.split("?")[0];
  imageName = imageName.split("#")[0];

  return imageName;
}

function checkIfMaterialsAllChanged() {
  let allowMaterialChange = true;

  if (Object.keys(materialChangeStatus).length > 0) {
    for (let key in materialChangeStatus) {
      if (!materialChangeStatus[key]) {
        allowMaterialChange = false;
      }
    }
  }

  return allowMaterialChange;
}

function sortOptionOrder(option1, option2) {
  let sort1 = 999;

  if (optionOrder.hasOwnProperty(option1.name)) {
    sort1 = optionOrder[option1.name];
  }

  let sort2 = 999;

  if (optionOrder.hasOwnProperty(option2.name)) {
    sort2 = optionOrder[option2.name];
  }

  if (sort1 > sort2) {
    return 1;
  } else {
    return -1;
  }
}

function takeScreenShot() {
  var productId = $('input[name="product-id"]').val();

  setTimeout(function () {
    viewer.takeScreenShotBase64().then((result) => {
      console.log(result);

      if (result) {
        localStorage.setItem("cart_img_base64_" + productId, result);
      }
    });
  }, 1600);
}

function getOpitons(components) {
  let options = [];

  for (var i = 0; i < components.length; i++) {
    const component = components[i];

    var materials = [];

    let materials_data = components[i]["materials"];

    console.log(materials_data);

    for (var j = 0; j < materials_data.length; j++) {
      const material_data = materials_data[j];

      if (
        material_data.thumbnail != "" &&
        material_data.name != "Default" &&
        typeof material_data.name !== "undefined"
      ) {
        let imageFile = getFileNameFromUrl(material_data.thumbnail);
        console.debug(imageFile);
        let zoomIn = "https://img.chromcrafthome.com/" + imageFile;

        const material = {
          name: material_data.name,
          materialId: material_data.id,
          thumbnail:
            material_data.thumbnail + "?x-oss-process=image/resize,m_fill,w_64",
          zoomin:
            material_data.thumbnail +
            "?x-oss-process=image/resize,m_fill,w_512", //zoomIn
        };

        materials.push(material);
      }
    }

    materials.sort((a, b) => {
      const aNumber = Number(a.name);
      const bNumber = Number(b.name);

      if (aNumber > bNumber) {
        return 1;
      } else if (aNumber < bNumber) {
        return -1;
      } else {
        return 0;
      }
    });

    const option = {
      name: component.name,
      materials: materials,
      componentIdStr: component.componentIds.join(","),
    };

    options.push(option);
  }

  options.sort(sortOptionOrder);

  return options;
}

function buildPanel(options) {
  let html = "";

  html += "<div class='cohoom-panel-content'>";

  options.forEach(function (option) {
    const materials = option.materials;

    html += "<div class='cohoom-option'>";
    html +=
      "<div class='cohoom-option-name'><span>" +
      option.name +
      "</span><i class='fa-solid fa-circle-check'></i></div>";

    html += "<div class='cohoom-option-content'>";

    materials.forEach(function (material) {
      if (!material.name.includes("\u9ed8\u8ba4") && material.name != material.materialId) {
        html +=
          "<div class='cohoom-block' data-material-zoomin='" +
          material.zoomin +
          "' data-option-name='" +
          option.name +
          "' data-component-id-str='" +
          option.componentIdStr +
          "' data-material-id='" +
          material.materialId +
          "'>";
        html +=
          "<img class='cohoom-material-thumbnail' src='" +
          material.thumbnail +
          "'/>";
        html += "<div class='cohoom-material-name'>" + material.name + "</div>";
        html += "</div>";
      }
    });

    html += "</div>";
    html += "</div>";
  });

  html += "</div>";

  html += "<div class='cohoom-panel-clear' onclick='hidePanel()'></div>";

  $("#cohoom-panel").append(html);
}

function buildMaterialNames(options) {
  let materialNames = {};

  for (var i = 0; i < options.length; i++) {
    let materials = options[i]["materials"];

    for (var j = 0; j < materials.length; j++) {
      const material = materials[j];
      materialNames[material.materialId] = material.name;
    }
  }

  return materialNames;
}

function buildOptionValues(opitons) {
  let optionValues = {};

  opitons.forEach(function (opiton) {
    optionValues[opiton.name] = null;
  });

  return optionValues;
}

function generateOptionDescription() {
  let description = "";

  const keys = Object.keys(optionValues);

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = optionValues[key];

    description += key + ": " + materialNames[value];

    if (i < keys.length - 1) {
      description += ", ";
    }
  }

  return description;
}

function validateOptionSelect() {
  let validated = true;

  const keys = Object.keys(optionValues);

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (optionValues[key] == null) {
      validated = false;
      break;
    }
  }

  return validated;
}

function validateAddCart() {
  let validated = true;

  const keys = Object.keys(optionValues);

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (optionValues[key] == null) {
      validated = false;
      break;
    }
  }

  if (validated) {
    $(".cart-btn-cover").remove();
    $('button[name="add"]').prop("disabled", false);
    $("#show-sticky-product").prop("disabled", false);
  }
}

function loadCohoomView(modelId) {
  // CHROMCRAFT FIX: if the Coohom SDK did not load (blocked/offline), do not throw; go to fallback.
  if (typeof koolViewer === "undefined" || !koolViewer.ViewerUISDK) {
    cohoomFixEnterFallback("viewer SDK missing");
    return;
  }
  try {
  viewer = new koolViewer.ViewerUISDK({
    mount: document.getElementById("cohoom-model"),
    modelId: modelId,
    useCoohomAPI: false,
    useCoohomCDN: true,
    locale: "en_US",
    lengthUnit: "in",
    autoRotate: true,
    enablePanel: false,
    enableOperationPanel: false,
    textureSize: 512,
    textureQuality: 50,
    enableMaterialNameBlacklist: true,
    //onerror: handleModelFail(),
    afterDidMount() {
      let componentsObj = {};
      
      const componentsData = viewer.getComponents();

      componentsData.forEach(function (component) {
        const key = component.name;

        if (typeof componentsObj[key] === "undefined") {
          componentsObj[key] = {
            name: component.name,
            materials: component.materials,
            componentIds: [],
          };
        }

        componentsObj[key].componentIds.push(component.id);
      });

      let components = [];

      Object.keys(componentsObj).forEach((key) => {
        components.push(componentsObj[key]);
      });

      const options = getOpitons(components);

      buildPanel(options);

      optionValues = buildOptionValues(options);
      materialNames = buildMaterialNames(options);

      // CHROMCRAFT FIX: options exist now; preselect defaults / leave fallback mode.
      cohoomFixOnOptionsReady();

      $(".skeleton-content").remove();
      $("#cohoom-model-skeleton").remove();

/*       $(".cohoom-model-wrap").append(
        '<img class="cohoom-usa" src="https://cdn.shopify.com/s/files/1/0808/3193/8871/files/usa-v2.png">'
      ); */
    },
    
  });
  } catch (err) {
    console.error("[cohoom-fix] 3D viewer failed to start:", err);
    cohoomFixEnterFallback("viewer error");
  }
}
function handleModelFail(){  
  console.error('An unexpected error occurred: Model did not load.');
  document.querySelector('.productView-top').style = "display:none";
}
function togglePanel() {
  let panel = $("#cohoom-panel");

  if (panel.hasClass("animate__fadeInLeft")) {
    panel.removeClass("animate__fadeInLeft");
    panel.addClass("animate__fadeOutLeft");
  } else {
    panel.removeClass("animate__fadeOutLeft");
    panel.addClass("animate__fadeInLeft");
    panel.show();
  }
}

function hidePanel() {
  let panel = $("#cohoom-panel");
  panel.removeClass("animate__fadeInLeft");
  panel.addClass("animate__fadeOutLeft");
}

$(document).on("click", ".cohoom-block", function () {
  if (checkIfMaterialsAllChanged()) {
    //add loading effect
    //html = '<div id="cohoom-model-skeleton">';
    //html += '<div class="skeleton-block"></div>';
    //html += '</div>';
    //$(".cohoom-model-wrap").append(html);

    //add material select effect
    $(this)
      .closest(".cohoom-option")
      .find(".fa-circle-check")
      .css("color", "#033c5a");
    $(this)
      .closest(".cohoom-option")
      .find(".cohoom-material-thumbnail")
      .removeClass("cohoom-material-thumbnail-selected");
    $(this)
      .find(".cohoom-material-thumbnail")
      .addClass("cohoom-material-thumbnail-selected");

    //get data
    const optionName = $(this).attr("data-option-name");
    const materialId = $(this).attr("data-material-id");
    const zoomin = $(this).attr("data-material-zoomin");
    const componentIdStr = $(this).attr("data-component-id-str");

    //change mateirals
    materialChangeStatus = {};
    let isMaterialChangeInProgress = false;
    const componentIds = componentIdStr.split(",");

    for (componentId of componentIds) {
      materialChangeStatus[componentId] = false;
    }

    //for (componentId of componentIds) {
    //  if (!isMaterialChangeInProgress) { // Check if a change is already in progress
    //    isMaterialChangeInProgress = true; // Set to true to block new changes
    //    viewer.changeMaterial(componentId, materialId).promise.then(() => {
    //      $('#cohoom-model-skeleton').remove();
    //      materialChangeStatus[componentId] = true;
    //      isMaterialChangeInProgress = false; // Reset the flag after completion
    //    }).catch((error) => {
    //      // Handle the error, especially the abort event
    //      if (error.type === 'abort') {
    //        console.warn('Request was aborted:', error);
    //        console.warn('Request was aborted:', componentId + " AND " + materialId);
    //        // Handle the abort specifically, e.g., provide user feedback or clean up
    //      } else {
    //        console.error('An unexpected error occurred:', error);
    //      }
    //      isMaterialChangeInProgress = false; // Ensure flag is reset on error
    //    });
    //  } else {
    //    console.warn('A material change is already in progress. Ignoring this request.');
    //  }
    //}

  



    
    async function processComponentIds(componentIds) {
      for (componentId of componentIds) {
        if (!isMaterialChangeInProgress) {
          isMaterialChangeInProgress = true;
          try {
            await viewer.changeMaterial(componentId, materialId).promise;
            $("#cohoom-model-skeleton").remove();
            materialChangeStatus[componentId] = true;
          } catch (error) {
            // Handle errors, including aborted requests
            if (error.type === "abort") {
              console.warn(
                "Request was aborted:",
                componentId + " , " + materialId
              );
            } else {
              console.error("An unexpected error occurred:", error);
            }
          } finally {
            isMaterialChangeInProgress = false;
          }
        } else {
          console.warn(
            "A material change is already in progress. Ignoring this request."
          );
        }
      }
    }

    // Usage:
    processComponentIds(componentIds).catch((error) => {
      // Handle any uncaught errors
    });
    //write option data
    optionValues[optionName] = materialId;
    const optionDescription = generateOptionDescription();
    $("#material").val(optionDescription);

    //validate cart
    validateAddCart();

    //store current view
    takeScreenShot();
  }
});

function handleBtnCoverClick() {
  // CHROMCRAFT FIX: the cover is no longer added, but keep this safe for any old markup.
  // It used to crash (Object.entries(undefined)) when the options never loaded.
  $(".cohoom-alert-wrap").remove();
  if (!optionValues || typeof optionValues !== "object") {
    cohoomFixCanSubmit();
    return;
  }

  let alertMessage = "Please select ";

  let notSelectedMaterials = [];

  Object.entries(optionValues).forEach(([key, value]) => {
    if (value == null) {
      notSelectedMaterials.push(key);
    }
  });

  alertMessage += notSelectedMaterials.join(", ");
  alertMessage += " in the material panel";

  let alertElement =
    '<div class="cohoom-alert-wrap animate__animated animate__fadeInDown animate__faster">';
  alertElement += '<div class="cohoom-alert-inner">' + alertMessage + "</div>";
  alertElement += "</div>";

  $("body").append(alertElement);

  setTimeout(function () {
    $(".cohoom-alert-wrap").removeClass("animate__fadeInDown");
    $(".cohoom-alert-wrap").addClass("animate__fadeOutUp");
  }, 3000);
}

$(document).ready(function () {
  $(document).on("mouseenter", ".cohoom-block", function () {
    if (window.innerWidth > 768) {
      const zoomin = $(this).attr("data-material-zoomin");

      $("#cohoom-material-zoomin").remove();
      let zoomInImage =
        '<div id="cohoom-material-zoomin" class="animate__animated animate__fadeIn" style="background-image: url(' +
        zoomin +
        ')"></div>';
      $(".cohoom-wrap").append(zoomInImage);
    }
  });

  $(document).on("mouseleave", ".cohoom-block", function () {
    $("#cohoom-material-zoomin").remove();
  });

  // CHROMCRAFT FIX: removed. Do not add ".cart-btn-cover" or disable Add to Cart on load.
  // (Old code appended the cover to .product-form__buttons / .empty-add-cart-button-wrapper
  //  and set button[name="add"] + #show-sticky-product disabled until all materials were picked.)
  cohoomFixInjectStyles();
  COHOOM_FIX.readyAt = Date.now();
  setTimeout(function () {
    if (!COHOOM_FIX.optionsReady) cohoomFixEnterFallback("timeout " + COHOOM_FIX.fallbackMs + "ms");
  }, COHOOM_FIX.fallbackMs);
  // Hide the old alert-free message when the shopper picks a material.
  $(document).on("click", ".cohoom-block", function () {
    if (!cohoomFixMissingOptions().length) cohoomFixHideMessage();
  });
});

